export var InsiderTermsAndConditionsStatus;
(function (InsiderTermsAndConditionsStatus) {
    InsiderTermsAndConditionsStatus["INSIDER_TERMS_AND_CONDITIONS_STATUS_UNKNOWN"] = "INSIDER_TERMS_AND_CONDITIONS_STATUS_UNKNOWN";
    InsiderTermsAndConditionsStatus["PENDING"] = "PENDING";
    InsiderTermsAndConditionsStatus["ACCEPTED"] = "ACCEPTED";
    InsiderTermsAndConditionsStatus["OUTDATED"] = "OUTDATED";
})(InsiderTermsAndConditionsStatus || (InsiderTermsAndConditionsStatus = {}));
